import GenericCard from "widgets/cards/generic";
import RatesSetup from "./components/ratesSetup";
import RateStructureSetup from "./components/rateStructureSetup";
import { useState } from "react";

const Rates = () => {
  const [rateId, setRateId] = useState("");

  return (
    <GenericCard extra="h-full">
      <div className={`flex h-full flex-col gap-2`}>
        <RateStructureSetup
          onUpdate={(val) => {
            setRateId(val);
          }}
        />
        <RatesSetup rateId={rateId} />
      </div>
    </GenericCard>
  );
};

export default Rates;
